import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectLanguage } from './Login/loginSlice';
import { texts } from './Common/common';
import { navigationIcons } from './DentappIcons';
import './DentappNavigation.css';

const DentappNavigation = () => {
    const currentLanguage = useSelector(selectLanguage);
    const location = useLocation();

    const menuItems = [
        { path: '/dentapp/lab', label: texts[currentLanguage].lab },
        { path: '/dentapp/settings', label: texts[currentLanguage].settings },
        { path: '/dentapp/job', label: texts[currentLanguage].work },
        { path: '/dentapp/statistic', label: texts[currentLanguage].statistics },
        { path: '/dentapp/diary', label: texts[currentLanguage].diary },
        { path: '/dentapp/cooperation', label: texts[currentLanguage].cooperation }
    ];

    // Не показываем меню на странице логина
    if (location.pathname === '/dentapp/login') {
        return null;
    }

    return (
        <nav className="dentapp-navigation">
            <div className="dentapp-nav-container">
                {menuItems.map((item, index) => {
                    const IconComponent = navigationIcons[index];
                    return (
                        <NavLink
                            key={item.path}
                            to={item.path}
                            className={({ isActive }) => 
                                `dentapp-nav-item ${isActive ? 'active' : ''}`
                            }
                        >
                            {({ isActive }) => (
                                <>
                                    <div className="dentapp-nav-icon">
                                        <IconComponent isActive={isActive} />
                                    </div>
                                    <span className="dentapp-nav-label">
                                        {item.label}
                                    </span>
                                </>
                            )}
                        </NavLink>
                    );
                })}
            </div>
        </nav>
    );
};

export default DentappNavigation;
